import { createSlice } from '@reduxjs/toolkit';
import { aRolesListSuccess, aSetUserList } from './common';

const initialState = {
  users: [],
  addError: '',
  roles: [],
  roleDisableEnableCb: false,
  selectedRoleId: null,
  rolePermissions: null,
  rolePermsCb: false,
  roleDelCallback: false,
};

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    aUserAddFailed(state, action) {
      state.addError = action.payload.error;
    },
    aPermissionsListSuccess(state, action) {
      state.permissions = action.payload.permissions;
    },
    aNewRoleSuccess(state) {
      state.roleCreateCallback = true;
    },
    aDelRoleSuccess(state) {
      state.roleDelCallback = true;
    },
    aDisableEnableRoleSuccess(state) {
      state.roleDisableEnableCb = true;
    },
    aRolePermissionsSuccess(state, action) {
      state.selectedRoleId = action.payload.forRole;
      state.rolePermissions = action.payload.permissions;
    },
    aRolePermissions(state) {
      state.selectedRoleId = null;
      state.rolePermissions = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(aSetUserList, (state, action) => {
      state.users = action.payload.userList.users;
    });
    builder.addCase(aRolesListSuccess,(state, action) => {
      state.roles = action.payload.roles;
      state.roleCreateCallback = false;
      state.roleDelCallback = false;
      state.roleDisableEnableCb = false;
      state.rolePermsCb = false;
    });
  },
});

export const {
  aUserAddFailed,
  aPermissionsListSuccess,
  aNewRoleSuccess,
  aDelRoleSuccess,
  aDisableEnableRoleSuccess,
  aRolePermissionsSuccess,
  aRolePermissions,
} = adminSlice.actions;


export default adminSlice.reducer;
